/**
 * Identidade anônima de visitante para dedupe de "views únicas" no backend
 * (event_funnel_events.session_id). Módulo separado de `attribution.js`: lá o
 * TTL é a janela de clique de uma campanha (30 dias); aqui é a vida de um
 * visitante, um propósito diferente que não deveria expirar junto.
 */

import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'event_analytics_session_id';
const TTL_DAYS = 365;

let memoryFallback = null;

function readStorage() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

function writeStorage(record) {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch {
        // Navegação anônima ou storage bloqueado: segue só na memória da aba.
        memoryFallback = record;
    }
}

function isExpired(record) {
    const createdAt = Date.parse(record?.created_at ?? '');

    if (!Number.isFinite(createdAt)) {
        return true;
    }

    return Date.now() - createdAt > TTL_DAYS * 24 * 60 * 60 * 1000;
}

export function getAnalyticsSessionId() {
    const existing = readStorage() || memoryFallback;

    if (existing?.id && !isExpired(existing)) {
        return existing.id;
    }

    const record = { id: uuidv4(), created_at: new Date().toISOString() };
    writeStorage(record);

    return record.id;
}
